export class SkillManagerForm { 
    name: string;
    constructor(skill: any) {
        {
            this.name = '';

        }
    }
}
